import { Component, OnInit } from '@angular/core';
import {IApplication, IPayment} from '../../../interfaces/entity';
import { ApplicationService } from '../../../services/application.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import {FormBuilder} from '@angular/forms';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-survey-list',
  templateUrl: './payment-list.component.html'
})
export class PaymentListComponent implements OnInit {

  heading = 'Payment List';
  subheading = 'Customer Payments Sent From OC.';
  icon = 'pe-7s-cash icon-gradient bg-sunny-morning';
  paymentList: IPayment[] = [];
  totalItems = 0;
  itemsPerPage = 10; // Set your desired items per page here
  currentPage = 1;
  closeResult: string;
  selectedPayment: IPayment;

  constructor(
    private service: ApplicationService,
    private ngxService: NgxUiLoaderService,
    private fb: FormBuilder,
    private modalService: NgbModal) {}
  searchForm = this.fb.group({
    column: [''],
    searchQuery: [''],
  });

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit() {
    this.getList(this.currentPage);
  }

  getList(page: number = 1, searchInfo?: any) {
    this.ngxService.start();
    this.service.getPayments({ page, size: this.itemsPerPage }, searchInfo).subscribe({
      next: (res: any) => {
        this.paymentList = res.data;
        this.totalItems = res.pagination.total;
        this.currentPage = page;
        this.ngxService.stop();
      },
      error: (res: any) => {
        this.paymentList = [];
        this.ngxService.stop();
      }
    });
  }

  onPageChange(page: number) {
    this.getList(page);
  }

  // modal
  open(content, payment: IPayment) {
    this.selectedPayment = payment;
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
}
